app.controller('popupGeneticDisorderCreateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'geneticDisorderModel',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, geneticDisorderModel) {

        function setData() {
            $scope.geneticDisorder = new GeneticDisorderVO();
            $scope.geneticDisorder.patient = new PatientVO();
            $scope.geneticDisorder.patient.id = $state.params.patientId;

            $scope.forms = {
                geneticDisorderForm: null
            };

            $scope.geneticDisorderActionType = 'save';
            $scope.actionInProgress = false;
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.geneticDisorderAction = function () {

                $scope.forms.geneticDisorderForm.$setSubmitted();
                if ($scope.forms.geneticDisorderForm.$valid) {

                    $scope.actionInProgress = true;
                    geneticDisorderModel.save($scope.geneticDisorder);

                    var successWatcherDisabler = $scope.$on(Event.GENETIC_DISORDER.SAVE.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                        $mdDialog.hide();
                    });
                    var errorWatcherDisabler = $scope.$on(Event.GENETIC_DISORDER.SAVE.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                    });
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);